<template>
    <div id="SpeechRecognition" class="animate__animated animate__fadeInUp">   
        <div id="speach-box">
            <div id="speech-icon">
                <img src="https://mcaloon.org/chat.png" @click="userTalk()" />
            </div>
            <div id="text-display">
                {{ transcript }}
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    name: 'speech-recognition',
    data: function () {
        return {
            transcript: "listening...",
            listen: false,
            sr: null
        };
    },
    props: [],
    methods: {
        startListen() {
            this.sr.start();
        },
        stopListen() {
            this.sr.stop();
        },
        userTalk() {
            console.log("userTalk clicked!")

            if(this.listen) {
                this.listen = false;
                this.sr.stop();
                console.log("STOPPED")
            } else {
                this.listen = true;
                this.sr.start();
                console.log("STARTED")
                //this.transcript = "ON"

                // setTimeout(() => {
                //     this.sr.stop();
                // }, 10000);
            }

            console.log(this.listen);
        },
        CheckForCommand(result) {
            const t = result[0].transcript;

            if(!this.listen) {
                    if(t.includes("assistant")) {
                        this.$parent.playSound("play","yes?");
                        this.transcript = ""
                        this.sr.stop()
                        setTimeout(() => this.sr.start(), 100)
                        this.listen = true;
                    }
            } else {
                if (t.includes('stop recording')) {
                    this.sr.stop()
                } else if (
                    t.includes('what is the time') ||
                    t.includes('what\'s the time')
                ) {
                    this.sr.stop()
                    alert(new Date().toLocaleTimeString())
                    setTimeout(() => this.sr.start(), 100)
                } else if (t.includes("blockchain")) {
                    this.transcript = ""
                    this.sr.stop()
                    setTimeout(() => this.sr.start(), 100)
                    this.listen = false;     
                    this.transcript = "";               
                    this.$parent.blockchainClick();
                } else if (t.includes("tracking")) {
                    this.transcript = ""
                    this.sr.stop()
                    setTimeout(() => this.sr.start(), 100)
                    this.listen = false;     
                    this.transcript = "";               
                    this.$parent.trackingClick();
                }
            }
        }        
    },
    mounted: function () {    

        console.log("sp test!!!");

        var SpeechRecognition = SpeechRecognition || webkitSpeechRecognition;
        this.sr = new SpeechRecognition();

        // sr config
        this.sr.continuous = true
        this.sr.interimResults = true

        this.sr.onstart = () => {
            console.log('SR Started')
            this.listen = true;
        }

        this.sr.onend = () => {
            console.log('SR Stopped')
            this.listen = false;
            this.transcript = ""
            
            // restart
            // this.listen = true;
            // this.sr.start();
            // this.transcript = ""
        }

        this.sr.onresult = (evt) => {
            for (let i = 0; i < evt.results.length; i++) {
                const result = evt.results[i]

                console.log(result);

                if (result.isFinal) this.CheckForCommand(result)
            }

            const t = Array.from(evt.results)
                .map(result => result[0])
                .map(result => result.transcript)
                .join('')
            
            this.transcript = t
        }  
    }
}
</script>

<style>
    #SpeechRecognition {
        display: none;
        position: absolute;
        top: -74px;
        width: 100%;
        text-align: center;
    }

    #speach-box{
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        border-radius: 100px;
        background-color: #676767;
        display: inline-block;
        margin: 0 auto;
        padding: 10px;
        width: 45%;
        max-width: 700px;
        height: 56px;
    }

    #speech-icon {
        float: left;
        position: relative;
    }

    #speech-icon img {
        border-radius: 43px; 
        height: 44px; 
        margin-top: -3px; 
        cursor: pointer;
        position: absolute;
    }

    #text-display {
        font-family: "IBM Plex Sans","Helvetica Neue",Arial,sans-serif;
        float: left;
        padding: 7px;
        padding-left: 80px;
        font-weight: 400;
        font-size: 16px;
        color: #fff
    }
</style>
